import {DeliveryChecksList} from '../models/delivery-checks-list.model';
import {DeliveryChecks} from '../models/delivery-checks.model';
import {Utilities} from '../../shared/utilities/utilities.model';
import {Alert} from '../models/alert.model';
import {DateUtilities} from '../../shared/utilities/date-utilities.model';
import {OrderDelivery} from '../models/order-delivery.model';
import {AttachedFile, BlobTypes} from '../../shared/models/attached-file.model';
import {UploadFileService} from '../../shared/service/upload-file.service';
import {OrderDetails} from '../models/order-details.model';
import {DigitalSignDocument} from '../../digital-sign/models/digital-sign-document.model';
import {DeliveryAttachedNemoModel} from '../models/delivery-attachments.model';

export class DeliveryUtilities {

	static INSURANCE_CERTIFICATES_IT_LABEL = 'Tagliando assicurativo';
	static REGISTRATION_BOOKS_IT_LABEL = 'Libretto di circolazione';

	public static getStandardInsuranceCertificatesLabel(locale?: any): string {
		switch (locale) {
			default:
				return DeliveryUtilities.INSURANCE_CERTIFICATES_IT_LABEL;
		}
	}

	public static getStandardRegistrationBooksLabel(locale?: any): string {
		switch (locale) {
			default:
				return DeliveryUtilities.REGISTRATION_BOOKS_IT_LABEL;
		}
	}

	public static sortCategoryChecks(model: any): Map<string, DeliveryChecksList> {
		const map = new Map<string, DeliveryChecksList>();
		model.forEach(
			(item) => {
				const txtCategory = item.txt_category;
				if (txtCategory) {
					let currentDeliveryCheckList = map.get(txtCategory);
					if (!currentDeliveryCheckList) {
						currentDeliveryCheckList = new DeliveryChecksList(txtCategory);
						map.set(txtCategory, currentDeliveryCheckList);
					}
					currentDeliveryCheckList.addChecks(new DeliveryChecks(item));
				}
			}
		);
		return map;
	}

	public static sortCategoryChecksShort(model: any): Map<string, DeliveryChecksList> {
		const map = new Map<string, DeliveryChecksList>();
		model.forEach(
			(item) => {
				const txtCategory = item.txt_category;
				if (txtCategory) {
					let currentDeliveryCheckList = map.get(txtCategory);
					if (!currentDeliveryCheckList) {
						currentDeliveryCheckList = new DeliveryChecksList(txtCategory);
						map.set(txtCategory, currentDeliveryCheckList);
					}
					const c = new DeliveryChecks();
					if (item.txt_description) {
						c.txt_description = item.txt_description;
					}
					if (item.txt_more) {
						c.txt_more = item.txt_more;
					}
					currentDeliveryCheckList.visibleDeliveryChecks.push(c.getBody());
				}
			}
		);
		return map;
	}

	static addDateLastAlert(lists: Map<string, DeliveryChecksList>, alerts: Alert[]) {
		if (!Utilities.isVoid(alerts) && !Utilities.isVoid(lists)) {
			alerts.forEach(
				alert => {
					if (!Utilities.isVoid(alert.txt_context)) {
						const list = lists.get(alert.txt_context);
						if (!Utilities.isVoid(list)) {
							list.visibleDeliveryChecks.forEach(
								dc => {
									if (Utilities.isVoid(dc.getDateAlert())) {
										let txt_detail = dc.txt_description;
										if (dc.txt_more) {
											txt_detail += dc.txt_more;
										}
										if (alert.txt_detail === txt_detail) {
											dc.setDateAlert(DateUtilities.getDateWithoutTimes(alert.date_rec_ins));
										}
									}
								});
						}
					}
				});
		}
	}

	static createPayloadCertificate(orderDelivery: OrderDelivery, deliveryChecksLists: Map<string, DeliveryChecksList>, orderDetails: OrderDetails, business_name: string) {
		if (Utilities.isVoid(OrderDelivery) || Utilities.isVoid(orderDetails)) {
			return {};
		}
		const body = {
			id_order: orderDelivery.id_order,
			val_months: orderDetails.val_months,
			txt_society_name: orderDelivery.txt_society_name,
			txt_driver_name: orderDelivery.txt_driver_name,
			txt_driver_surname: orderDelivery.txt_driver_surname,
			txt_driver_city: orderDelivery.txt_driver_city,
			txt_driver_zip_code: orderDelivery.txt_driver_zip_code,
			txt_driver_address: orderDelivery.txt_driver_address,
			txt_driver_address_number: orderDelivery.txt_driver_address_number,
			txt_driver_phone: orderDelivery.txt_driver_phone,
			txt_driver_email: orderDelivery.txt_driver_email,
			txt_driver_license_number: orderDelivery.txt_driver_license_number,
			txt_driver_license_by: orderDelivery.txt_driver_license_by,
			ordercardelivery_date_license_release_textbox: orderDelivery.ordercardelivery_date_license_release_textbox,
			ordercardelivery_date_license_validity_textbox: orderDelivery.ordercardelivery_date_license_validity_textbox,
			ordercardelivery_vehicle_recipient_listbox: orderDelivery.ordercardelivery_vehicle_recipient_listbox,
			txt_delegate_name: orderDelivery.txt_delegate_name,
			txt_delegate_surname: orderDelivery.txt_delegate_surname,
			txt_delegate_city: orderDelivery.txt_delegate_city,
			txt_delegate_zip_code: orderDelivery.txt_delegate_zip_code,
			txt_delegate_address: orderDelivery.txt_delegate_address,
			txt_delegate_address_number: orderDelivery.txt_delegate_address_number,
			txt_delegate_phone: orderDelivery.txt_delegate_phone,
			txt_delegate_email: orderDelivery.txt_delegate_email,
			txt_delegate_license_number: orderDelivery.txt_delegate_license_number,
			txt_delegate_license_by: orderDelivery.txt_delegate_license_by,
			date_delegate_license_release: orderDelivery.date_delegate_license_release,
			date_delegate_license_validity: orderDelivery.date_delegate_license_validity,
			txt_make: orderDelivery.txt_make,
			txt_model: orderDelivery.txt_model,
			txt_plate: orderDelivery.txt_plate,
			val_start_km: orderDelivery.val_start_km,
			txt_color_ext: orderDelivery.txt_color_ext,
			txt_color_int: orderDelivery.txt_color_int,
			txt_tank_level: orderDelivery.txt_tank_level,
			txt_prerent_description: orderDelivery.txt_prerent_description,
			txt_prerent_plate: orderDelivery.txt_prerent_plate,
			val_prerent_km: orderDelivery.val_prerent_km,
			txt_prerent_owner: orderDelivery.txt_prerent_owner,
			business_name: business_name,
			txt_template: orderDelivery.txt_template,
			cod_veh_type: orderDetails.cod_veh_type,
			id_typ_purchase: orderDetails.id_typ_purchase,
			txt_customer_contract_reference: orderDelivery.txt_customer_contract_reference,
			option_checks: DeliveryUtilities.createPayloadDeliveryChecksCertificate(deliveryChecksLists)
		};
		return JSON.parse(Utilities.escapeSpecialChart(JSON.stringify(body)));
	}

	static createPayloadDeliveryChecksCertificate(deliveryChecksLists: Map<string, DeliveryChecksList>) {
		const option_checks = [];
		if (!Utilities.isVoid(deliveryChecksLists)) {
			const list = Array.from(deliveryChecksLists.keys());
			for (const key of list) {
				const checks = deliveryChecksLists.get(key);
				for (const check of checks.visibleDeliveryChecks) {
					if (check.check === 0) {
						if (check.wd_type === DeliveryChecks.WD_TYPE_DELIVERY_CHECK
							&& check.flag_active
							&& DeliveryUtilities.deliveryCheckToTake(check.txt_category)) {
							option_checks.push(check.txt_description);
							continue;
						}
						if (check.wd_type === DeliveryChecks.WD_TYPE_OPTION_CHECK
							&& check.txt_category === DeliveryChecksList.ACCESSORIES && check.isCodOwnerFACT()) {
							option_checks.push(check.txt_description);
						}
					}
				}
			}
		}
		return option_checks;
	}

	static deliveryCheckToTake(txt_category: string): boolean {
		return txt_category === DeliveryChecksList.ACCESSORIES ||
			txt_category === DeliveryChecksList.FUEL_CARDS ||
			txt_category === DeliveryChecksList.SPECIAL_DOCUMENTS ||
			txt_category === DeliveryChecksList.EQUIPMENT;
	}

	static createPayloadLetter(orderDelivery: OrderDelivery, orderDetails: OrderDetails, business_name: string) {
		if (Utilities.isVoid(OrderDelivery) || Utilities.isVoid(orderDetails)) {
			return {};
		}
		const body = {
			id_order: orderDelivery.id_order,
			val_months: orderDetails.val_months,
			txt_society_name: orderDelivery.txt_society_name,
			txt_driver_name: orderDelivery.txt_driver_name,
			txt_driver_surname: orderDelivery.txt_driver_surname,
			txt_driver_city: orderDelivery.txt_driver_city,
			txt_driver_zip_code: orderDelivery.txt_driver_zip_code,
			txt_driver_address: orderDelivery.txt_driver_address,
			txt_driver_address_number: orderDelivery.txt_driver_address_number,
			txt_driver_phone: orderDelivery.txt_driver_phone,
			txt_driver_email: orderDelivery.txt_driver_email,
			txt_driver_license_number: orderDelivery.txt_driver_license_number,
			txt_driver_license_by: orderDelivery.txt_driver_license_by,
			ordercardelivery_date_license_release_textbox: orderDelivery.ordercardelivery_date_license_release_textbox,
			ordercardelivery_date_license_validity_textbox: orderDelivery.ordercardelivery_date_license_validity_textbox,
			ordercardelivery_vehicle_recipient_listbox: orderDelivery.ordercardelivery_vehicle_recipient_listbox,
			txt_delegate_name: orderDelivery.txt_delegate_name,
			txt_delegate_surname: orderDelivery.txt_delegate_surname,
			txt_delegate_city: orderDelivery.txt_delegate_city,
			txt_delegate_zip_code: orderDelivery.txt_delegate_zip_code,
			txt_delegate_address: orderDelivery.txt_delegate_address,
			txt_delegate_address_number: orderDelivery.txt_delegate_address_number,
			txt_delegate_phone: orderDelivery.txt_delegate_phone,
			txt_delegate_email: orderDelivery.txt_delegate_email,
			txt_delegate_license_number: orderDelivery.txt_delegate_license_number,
			txt_delegate_license_by: orderDelivery.txt_delegate_license_by,
			date_delegate_license_release: orderDelivery.date_delegate_license_release,
			date_delegate_license_validity: orderDelivery.date_delegate_license_validity,
			txt_make: orderDelivery.txt_make,
			txt_model: orderDelivery.txt_model,
			txt_plate: orderDelivery.txt_plate,
			val_start_km: orderDelivery.val_start_km,
			txt_color_ext: orderDelivery.txt_color_ext,
			txt_color_int: orderDelivery.txt_color_int,
			txt_tank_level: orderDelivery.txt_tank_level,
			business_name: business_name,
			txt_template: orderDelivery.txt_template,
			cod_veh_type: orderDetails.cod_veh_type,
			id_typ_purchase: orderDetails.id_typ_purchase,
		};
		return JSON.parse(Utilities.escapeSpecialChart(JSON.stringify(body)));
	}

	static getDeliveryAttachmentsBody(files: AttachedFile[]): any[] {
		const result = [];
		if (!Utilities.isVoid(files) && files.length > 0) {
			for (let i = 0; i < files.length; i++) {
				result.push(DeliveryUtilities.getDeliveryAttachedBody(files[i]));
			}
		}
		return result;
	}

	static getDeliveryAttachedBody(attachedFile: AttachedFile): any {
		return {
			uuid: attachedFile.uuid,
			file_name: attachedFile.file_name,
			blob_name: attachedFile.blob_name,
			file_size: attachedFile.file_size,
			mime_type: attachedFile.mime_type,
			blob_type: attachedFile.blob_type,
			description: attachedFile.description
		};
	}

	static checkDriverDocumentAddedToDossier(documentsAdded: string[]): boolean {
		return Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE, BlobTypes.CODICE_FISCALE])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE, BlobTypes.CODICE_FISCALE_FRONTE, BlobTypes.CODICE_FISCALE_RETRO])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE_FRONTE, BlobTypes.PATENTE_RETRO, BlobTypes.CODICE_FISCALE])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.PATENTE_FRONTE, BlobTypes.PATENTE_RETRO, BlobTypes.CODICE_FISCALE_FRONTE, BlobTypes.CODICE_FISCALE_RETRO]);
	}

	static checkDelegateDocumentAddedToDossier(documentsAdded: string[]): boolean {
		return Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.DELEGATE_PATENTE, BlobTypes.DELEGATE_CODICE_FISCALE])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.DELEGATE_PATENTE, BlobTypes.DELEGATE_CODICE_FISCALE_FRONTE, BlobTypes.DELEGATE_CODICE_FISCALE_RETRO])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.DELEGATE_PATENTE_FRONTE, BlobTypes.DELEGATE_PATENTE_RETRO, BlobTypes.DELEGATE_CODICE_FISCALE])
			|| Utilities.arrayIncludesArray(documentsAdded, [BlobTypes.DELEGATE_PATENTE_FRONTE, BlobTypes.DELEGATE_PATENTE_RETRO, BlobTypes.DELEGATE_CODICE_FISCALE_FRONTE, BlobTypes.DELEGATE_CODICE_FISCALE_RETRO]);
	}

	static createDigitalSignDocumentByAttachedFile(file: DeliveryAttachedNemoModel, infocert_signer_id: string) {
		const result = new DigitalSignDocument();
		if (!Utilities.isVoid(file)) {
			result.client_document_id = Utilities.getUUID();
			result.infocert_signer_id = infocert_signer_id;
			result.infocert_document_id = file.description;
			result.infocert_document_type = file.description;
			result.policy_compose = false;
			result.policy_sign = false;
			result.policy_archive = false;
			result.file_manager_id = file.uuid;
			result.signature_fields = [];
		}
		return result;
	}


	static createCertificateLikeDigitalSignDocument(certificateUUID: string, location: string, orderDelivery: OrderDelivery) {
		const signerFiscalCode = (!orderDelivery.delegateExist() ? orderDelivery.txt_fiscal_code_driver : orderDelivery.txt_fiscal_code_delegate);
		const signerCompleteName = (!orderDelivery.delegateExist() ? orderDelivery.txt_driver_name + ' ' + orderDelivery.txt_driver_surname : orderDelivery.txt_delegate_name + ' ' + orderDelivery.txt_delegate_surname);
		if (Utilities.isVoid(location)) {
			location = '';
		}
		return new DigitalSignDocument(
			{
				client_document_id: Utilities.getUUID(),
				infocert_document_id: 'ALD-adc1',
				infocert_document_type: BlobTypes.ATTESTATO_DI_CONSEGNA,
				policy_compose: false,
				policy_sign: true,
				policy_archive: true,
				file_manager_id: certificateUUID,
				signature_fields: [
					{
						signer_id: 'richiedente1',
						name: 'driver_signature',
						reason: 'Dichiarazione del sottoscrittore',
						location: ''
					},
					{
						signer_id: 'IR1',
						name: 'ir_signature',
						reason: 'Dati veicolo a noleggio e/o dati veicolo pre-rent e accessori',
						location: ''
					}
				],
				archiving_policy: {
					document_class: 'verbali_service_point',
					attributes: {
						doc_type: BlobTypes.ATTESTATO_DI_CONSEGNA,
						file_manager_id: certificateUUID,
						order_id: orderDelivery.id_order,
						plate: orderDelivery.txt_plate,
						reference_id: orderDelivery.id_order,
						reference_type: UploadFileService.ORDER_RESOURCE_TYPE,
						signer_complete_name: signerCompleteName,
						signer_fiscal_code: signerFiscalCode,
						society_name: orderDelivery.txt_society_name
					}
				}
			});
	}

	static createAttachedFileFromDeliveryAttachedNemo(file: DeliveryAttachedNemoModel, resource_type: string, resource_id: any): AttachedFile {
		const result = new AttachedFile();
		result.file_name = file.file_name;
		result.file_size = file.file_size;
		result.blob_name = file.blob_name;
		result.resource_id = resource_id;
		result.resource_type = resource_type;
		result.blob_type = file.blob_type;
		result.uuid = file.uuid;
		result.mime_type = file.mime_type;
		result.description = file.description;

		return result;
	}
}
